//lazy background
window.addEventListener("load", function (event) {
    //get all images to be obsevered
    const images = document.querySelectorAll('div[data-src]');
    //create the observer
    var observer = new IntersectionObserver((entries, observer) => {

        for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.intersectionRatio > 0) {
                //console.log('in the view');
                //switch image src from placeholder to real one
                const imgSrc = entry.target.dataset.src;
                //entry.target.src = imgSrc;
                entry.target.style.backgroundImage = "url(" + imgSrc + ")";
                entry.target.classList.add("is-visible");
                
                //apply src to img tag
                var imageTag = entry.target.getElementsByTagName("img")[0];
                imageTag.setAttribute("src", imgSrc);

                //remove observer once in view
                observer.unobserve(entry.target);
            } else {
                //console.log('out of view');
            }
        }
    });

    for (var x = 0; x < images.length; x++) {
        var element = images[x];
        observer.observe(element);
    }

}, false);

//lazy image
window.addEventListener("load", function (event) {
    //get all images to be obsevered
    const images = document.querySelectorAll('.lazy-image');
    //create the observer
    var observer = new IntersectionObserver((entries, observer) => {

        for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.intersectionRatio > 0) {
                //console.log('in the view');
                //switch image src from placeholder to real one
                const imgSrc = entry.target.dataset.src;
                //entry.target.src = imgSrc;
                entry.target.src = imgSrc;
                entry.target.classList.add("visible");
                //remove observer once in view
                observer.unobserve(entry.target);
            } else {
                //console.log('out of view');
            }
        }

    });
    for (var x = 0; x < images.length; x++) {
        var element = images[x];
        observer.observe(element);
    }

}, false);




// WEBPACK FOOTER //
// ./scripts/lazy-images.js